import { observer } from 'mobx-react-lite'
import React, { useContext, useMemo, useState } from 'react'
import { CampaignContext } from '../../../../../contexts/CampaignContext'
import Switch from '../../../../FormComponents/Switch'
import Formulas from './ImportantMetricsParts/Formulas'
import OverviewPaid from './ImportantMetricsParts/OverviewPaid'
import ProviderMetrics from './ImportantMetricsParts/ProviderMetrics'
import ShowAll from './ImportantMetricsParts/ShowAll'
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'

export default observer(function ImportantMetrics({ values, setFieldValue, handleChange, handleBlur }) {
  const { selectedScenario } = useContext(CampaignContext)
  const [selected, setSelected] = useState('show_all')
  const [open, setOpen] = useState(true)

  const providers = useMemo(() => selectedScenario.actions.reduce((result, action) => {
    if(action.visible_in_budget && !result.includes(action.provider)) result.push(action.provider)
    return result
  }, []), [selectedScenario, selectedScenario.actions, selectedScenario.actions.length])

  return (
    <div className="bg-white dark:bg-rb-dark-mode border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter rounded-2xl p-4 mt-4">
      <div className="flex justify-between items-center mb-8">
        <p className="font-bold text-xl dark:text-white">Important Metrics</p>
        <Switch name="important_metrics_visible" value={values.important_metrics_visible} onChange={({ target: { checked }}) => setFieldValue('important_metrics_visible', checked, true)} eyeSwitch />
      </div>
      {values.important_metrics_visible && (
        <>
          <div className="flex gap-4 border-b-1 dark:border-rb-dark-mode-lighter">
            <button type='button' className={`dark:text-white ${selected === 'show_all' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setSelected('show_all')}>Show all</button>
            {providers.includes('instagram') && <button type='button' className={`dark:text-white ${selected === 'instagram' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setSelected('instagram')}>Instagram</button>}
            {providers.includes('tiktok') && <button type='button' className={`dark:text-white ${selected === 'tiktok' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setSelected('tiktok')}>Tiktok</button>}
            {providers.includes('youtube') && <button type='button' className={`dark:text-white ${selected === 'youtube' && 'text-rb-green dark:text-rb-green border-b-1 border-rb-green dark:border-rb-green'}`} onClick={() => setSelected('youtube')}>Youtube</button>}
          </div>

          <div className="flex justify-between mt-8">
            <p className="font-bold dark:text-white">Overview Goals / Actual</p>
            <button type="button" className="dark:text-white" onClick={() => setOpen(!open)}>{open ? <ChevronUp /> : <ChevronDown /> }</button>
          </div>
          <div className={`${open ? selected === 'show_all' ? 'h-[1170px]' : 'h-[620px]' : 'h-0 overflow-hidden'} transition-all duration-300`}>
            {selected === 'show_all'
              && <ShowAll values={values} setFieldValue={setFieldValue} handleChange={handleChange} handleBlur={handleBlur} />
              || <ProviderMetrics key={selected} provider={selected} />}
          </div>
          <OverviewPaid values={values} setFieldValue={setFieldValue} handleChange={handleChange} handleBlur={handleBlur} />
          <Formulas values={values} setFieldValue={setFieldValue} handleChange={handleChange} handleBlur={handleBlur} />
        </>
      )}
    </div>
  )
})